import React, { FunctionComponent } from "react"
import Grid from "../../components/Grid/Grid"
import LinkItem from "../../components/Grid/LinkItem"
import Loader from "../../components/Loader/Loader"
import Pagination from "../../components/Pagination/Pagination"
import Seo from "../../components/Seo/Seo"
import { iSpace, iSpaceQuery } from "../../definitions/Space"
import { useData } from "../../hooks/useData"
import SpaceFilters from "./Filters"
import Item from "./Item"

const Spaces: FunctionComponent = () => {
  const { total, data, loading, setQuery, query } = useData<
    iSpaceQuery,
    iSpace
  >({
    link: "/v2/spaces",
    defaultQuery: {},
    shouldPingForData: true,
    shouldPushQuery: true,
  })

  return (
    <>
      <Seo title={"Spaces"} />
      <div className="content">
        <div className="content-header">
          <h1>Spaces ({total})</h1>
          <SpaceFilters setQuery={setQuery} query={query} />
        </div>
        <div className="grid-wrap">
          {loading ? (
            <Loader />
          ) : data.length ? (
            <Grid>
              {data.map((space, i) => (
                <LinkItem key={space._id} url={"/spaces/" + space.url}>
                  <Item key={i} {...space} />
                </LinkItem>
              ))}
            </Grid>
          ) : (
            <div className="no-data">No matching results.</div>
          )}
        </div>
        <Pagination total={total} limit={50} setQuery={setQuery} />
      </div>
    </>
  )
}

export default Spaces
